export default __webpack_public_path__ + "static/media/star.4ed040d1.png";